<script setup lang="ts">
import {
  AccordionHeader,
  AccordionHeaderProps,
  useForwardProps,
} from 'radix-vue'

const props = defineProps<AccordionHeaderProps>()
const forwarded = useForwardProps(props)
</script>

<template>
  <AccordionHeader v-bind="forwarded">
    <slot></slot>
  </AccordionHeader>
</template>
